import {
  FormData,
} from './Config/types'
import { API_URL } from './Config/config'
import { defaultInputValues } from './Config/defaults'
import {
  CASH_FLOW_DISCOUNT_MIN,
  CASH_FLOW_DISCOUNT_MAX,
  MARGIN_OF_SAFETY_MIN,
  MARGIN_OF_SAFETY_MAX,
  NUMBER_OF_YEARS_MIN,
  NUMBER_OF_YEARS_MAX,
  GROWTH_RATE_MIN,
  MARKET_CAP_FCF_RATIO_MIN,
} from './Config/validationRules'
import { safeParseFloat, safeParseInt, safeParseOptionalFloat } from './utils/validation'

export const isMobileDevice = () => {
  return /Mobi|Android/i.test(navigator.userAgent)
}


export const wakeupCall = async (signal?: AbortSignal) => {
  try {
    const response = await fetch(API_URL + '/marco', { signal })
    if (response.ok) {
      console.log('Wakeup call responded successfully')
    } else {
      console.error(
        'Wakeup call failed with error code: ' + response.status)
    }
  } catch (error) {
    // Only log non-abort errors
    if (error instanceof Error && error.name !== 'AbortError') {
      console.error('An error occurred:', error)
    }
  }
}

export const getNewFormData = (params: URLSearchParams) => {
  const symbolsFromParams = params.get('symbols')

  const newFormData: FormData = {
    symbols: symbolsFromParams 
      ? symbolsFromParams.split(',').map(symbol => symbol.trim()).filter(s => s !== '') 
      : defaultInputValues.symbols,
    annual_cash_flow_discount: safeParseFloat(
      params.get('annual_cash_flow_discount'),
      defaultInputValues.annual_cash_flow_discount,
      CASH_FLOW_DISCOUNT_MIN,
      CASH_FLOW_DISCOUNT_MAX
    ),
    margin_of_safety: safeParseFloat(
      params.get('margin_of_safety'),
      defaultInputValues.margin_of_safety,
      MARGIN_OF_SAFETY_MIN,
      MARGIN_OF_SAFETY_MAX
    ),
    number_of_years: safeParseInt(
      params.get('number_of_years'),
      defaultInputValues.number_of_years,
      NUMBER_OF_YEARS_MIN,
      NUMBER_OF_YEARS_MAX
    ),
    maximal_average_growth_rate: safeParseFloat(
      params.get('maximal_average_growth_rate'),
      defaultInputValues.maximal_average_growth_rate ?? 0.1,
      GROWTH_RATE_MIN
    ),
    maximal_market_cap_to_free_cash_flow_ratio: safeParseOptionalFloat(
      params.get('maximal_market_cap_to_free_cash_flow_ratio'),
      MARKET_CAP_FCF_RATIO_MIN
    ),
    average_growth_rate_annual: safeParseOptionalFloat(
      params.get('average_growth_rate_annual'),
      GROWTH_RATE_MIN
    ),
    average_market_cap_to_free_cash_flow_ratio: safeParseOptionalFloat(
      params.get('average_market_cap_to_free_cash_flow_ratio'),
      GROWTH_RATE_MIN
    ),
  }
  return newFormData
}

export const getUpdatedURL = (data: FormData) => {
  const params = new URLSearchParams();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      if (Array.isArray(value)) {
        // For arrays, join the array into a string with commas
        params.set(key, value.join(','));
      } else if (typeof value === 'string') {
        // For strings, check if it is not an empty string
        if (value !== '') {
          params.set(key, value);
        }
      } else {
        // For other types, convert to string directly
        params.set(key, String(value));
      }
    }
  });
  return params;
};
